var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37358 16.5641C1.37358 17.7029 2.26307 18.6346 3.35023 18.6346H11.2568C12.344 18.6346 13.2335 17.7029 13.2335 16.5641V4.14103H1.37358V16.5641ZM3.80486 9.19308L5.19841 7.73337L7.30354 9.92811L9.39879 7.73337L10.7923 9.19308L8.69708 11.3878L10.7923 13.5826L9.39879 15.0423L7.30354 12.8475L5.20829 15.0423L3.81475 13.5826L5.91 11.3878L3.80486 9.19308ZM10.7627 1.03526L9.77436 0H4.83272L3.8444 1.03526H0.385254V3.10577H14.2218V1.03526H10.7627Z",
    fill: "#F9FCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a47b4168e5d1b71d2f6384d0dca51c94.svg";
export { ForwardRef as ReactComponent };